import {
  DEFAULT_PENSIEVE_LEVEL_RANGE,
  normalizePensieveLevelRange,
  type PensieveLevelRange,
} from '@deadpan/shared';

const STORAGE_KEY = 'deadpan.pensieveLevelRange.v1';

export function loadPensieveLevelRange(): PensieveLevelRange {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return DEFAULT_PENSIEVE_LEVEL_RANGE;
    const p = JSON.parse(raw) as { min?: number; max?: number };
    if (typeof p.min !== 'number' || typeof p.max !== 'number') {
      return DEFAULT_PENSIEVE_LEVEL_RANGE;
    }
    if (!Number.isInteger(p.min) || !Number.isInteger(p.max)) {
      return DEFAULT_PENSIEVE_LEVEL_RANGE;
    }
    if (p.min < 0 || p.min > 3 || p.max < 0 || p.max > 3) {
      return DEFAULT_PENSIEVE_LEVEL_RANGE;
    }
    return normalizePensieveLevelRange({
      min: p.min as PensieveLevelRange['min'],
      max: p.max as PensieveLevelRange['max'],
    });
  } catch {
    return DEFAULT_PENSIEVE_LEVEL_RANGE;
  }
}

export function persistPensieveLevelRange(range: PensieveLevelRange): void {
  try {
    const n = normalizePensieveLevelRange(range);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(n));
  } catch {
    /* private mode / quota */
  }
}
